import type { SalesDateAxis } from '@/hooks/useSales';

export type SaleDisplayDateFields = {
  status?: string | null;
  created_at_formatted?: string | null;
  processed_at_formatted?: string | null;
  paid_at_formatted?: string | null;
  refunded_at_formatted?: string | null;
  chargeback_at_formatted?: string | null;
};

const isChargebackStatus = (status: string): boolean =>
  status === 'chargeback' || status === 'pre_chargeback';

/**
 * Resolve a data formatada a exibir na listagem (por eixo) ou nos detalhes (por status).
 */
export function resolveSaleDisplayDate(
  sale: SaleDisplayDateFields,
  options?: { dateAxis?: SalesDateAxis },
): string {
  const fallback =
    sale.processed_at_formatted || sale.created_at_formatted || '';
  const status = sale.status ?? '';

  if (options?.dateAxis === 'processing') {
    return sale.processed_at_formatted || fallback;
  }

  if (options?.dateAxis === 'paid') {
    return sale.paid_at_formatted || fallback;
  }

  if (options?.dateAxis === 'refunded') {
    if (isChargebackStatus(status)) {
      return sale.chargeback_at_formatted || fallback;
    }

    return sale.refunded_at_formatted || fallback;
  }

  // Detalhes / sem eixo: escolher pela status da order
  if (isChargebackStatus(status)) {
    return sale.chargeback_at_formatted || fallback;
  }

  if (status === 'refunded') {
    return sale.refunded_at_formatted || fallback;
  }

  if (status === 'paid') {
    return sale.paid_at_formatted || fallback;
  }

  return fallback;
}
